import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
/***
 * Check of the User is a partner
 */
@Injectable({
  providedIn: 'root'
})
export class RolePartnerGuard  {
  /**
   * constructor
   * @param router 
   * @param authenticationService 
   */
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  /**
   * Check if the User is a Partner
   * @param route 
   * @param state 
   * @returns 
   */
  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const currentUser = this.authenticationService.decodedToken$.value;
    if (currentUser.role == "ROLE_PARTNER") {
      // logged in so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/']);
    return false;
  }
}